export default __webpack_public_path__ + "static/media/avatar.ac552315.png";